import React, {useEffect} from 'react';
import ModelUploadPageHeader from '../common/ModelUploadPageHeader';
import ModelEditFiles, {ModelEditFilesProps} from '../../model/common/ModelEdit/ModelEditFiles/ModelEditFiles';
import ModelUploadFooter from '../common/ModelUploadFooter';
import {trackFilesTabEvent} from '../../../../tracking/tracking';
import StepFilesRedesigned from './StepFilesRedesigned';
import ModelUploadFooterAntd from '../common/ModelUploadFooterAntd';

type StepFileProps = Omit<ModelEditFilesProps, 'buttons'> & {
  useRedesign?: boolean;
  onBack?: () => void;
  buttons?: (params: {
    backText?: string;
    onNext?: () => void;
    onBack?: () => void;
    disableNext?: boolean;
    showBack?: boolean;
  }) => React.ReactNode;
};

const renderButtons = () => {
  return <ModelUploadFooter />;
};

const renderButtonsAntd = (params?: any) => {
  return <ModelUploadFooterAntd {...params} />;
};

const StepFiles: React.FC<StepFileProps> = (props) => {
  const {useRedesign = true, model, files = [], onChange, onSubmit, onBack, buttons} = props;

  useEffect(() => {
    trackFilesTabEvent();
  }, []);

  // Use redesigned version only when enabled
  if (useRedesign) {
    return (
      <StepFilesRedesigned
        model={model}
        files={files}
        onChange={onChange}
        onSubmit={onSubmit}
        onBack={onBack}
        buttons={buttons || renderButtonsAntd}
      />
    );
  }

  // Original version
  return (
    <div>
      <ModelUploadPageHeader
        title="Upload files from Bitbucket or your local storage"
        subTitle={
          <>
            If you already have existing project in Bitbucket, you can upload from there.
            <br />
            For Excel models or scripted languages not in Bitbucket, please use Upload from local.
          </>
        }
      />
      <ModelEditFiles
        uploadFlow={true}
        buttons={renderButtons}
        model={model}
        files={files}
        onChange={onChange}
        onSubmit={onSubmit}
      />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default StepFiles;
